export default __webpack_public_path__ + "static/media/logo_2.33d59c37.svg";